import { useMsal } from "@azure/msal-react";
import { app, authentication } from "@microsoft/teams-js";
import Button from '@mui/material/Button';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../AppContext';
import { PowerBiLoginRequest } from "../AuthConfig";
import { useUnifiedAuthentication } from "../components/CommonComponents";
import { MenuItem } from "../models/models";
import { isRunningInTeams, LoginUser } from '../services/AppOwnsDataWebApi';
import HeaderMenu from './HeaderMenu';

const LoginMenu = () => {
    const isAuthenticated = useUnifiedAuthentication();
    const { instance } = useMsal();
    const navigate = useNavigate();
    const { embeddingData, setDisplayMainLoader, isSuperUser, setIsTeamsAuthenticated, isTeamsAuthenticated, setTeamsUser } = useContext(AppContext);

    const loginButtonStyles = isAuthenticated ? {
        color: 'white',
        backgroundColor: 'transparent',
        textDecoration: 'none',
        fontWeight: '700',
        fontSize: '16px',
        textTransform: 'uppercase' as 'uppercase',
        fontFamily: "'Barlow', sans-serif",
        zIndex: 4,
        letterSpacing: 'normal',
        "&:hover": {
            backgroundColor: 'transparent',
        },
    } : {
        color: 'white',
        backgroundColor: 'transparent',
        textDecoration: 'none',
        fontWeight: '700',
        fontSize: '16px',
        textTransform: 'uppercase' as 'uppercase',
        fontFamily: "'Barlow', sans-serif",
        letterSpacing: 'normal',
        zIndex: 4,
        "&:hover": {
            backgroundColor: 'transparent',
        },
    }

    const loginUser = async () => {
        const inTeams = await isRunningInTeams();
        if (inTeams) {
            try {
                const context = await app.getContext();
                const token = await authentication.getAuthToken({ silent: true });
                await LoginUser(context.user?.userPrincipalName, context.user?.displayName);
                setTeamsUser({
                    userPrincipalName: context.user?.userPrincipalName,
                    displayName: context.user?.userPrincipalName
                });
                setIsTeamsAuthenticated(true);
                navigate("/");
            }
            catch (error) {
                console.error("Teams SSO failed", error);
            }
        }
        else
            instance.loginRedirect(PowerBiLoginRequest);
    };


    const logoutUser = () => {
        setDisplayMainLoader(false);
        embeddingData.setRedirectUserToReport(false);

        if (isTeamsAuthenticated === true)
            setIsTeamsAuthenticated(false);

        navigate("/");

        if (isTeamsAuthenticated === false)
            instance.logoutRedirect();
    };

    const permissionBasedObjects: MenuItem[] = [
        {
            id: -1000,
            name: 'SETTINGS',
            level: 0,
            parentId: null,
            link: null,
            displayOrder: 1000,
            isAssigned: true
        },
        {
            id: -1001,
            name: 'MANAGEMENT',
            level: 1,
            parentId: -1000,
            link: null,
            displayOrder: 1000,
            isAssigned: true
        },
        {
            id: -1002,
            name: 'USER',
            level: 2,
            parentId: -1001,
            link: '/usermanagement',
            displayOrder: 0,
            isAssigned: true
        },
        {
            id: -1003,
            name: 'CONTENT',
            level: 2,
            parentId: -1001,
            link: '/contentmanagement',
            isAssigned: true,
            displayOrder: 3
        },
        {
            id: -1004,
            name: 'PACKAGE',
            level: 2,
            parentId: -1001,
            link: '/content-role-management',
            isAssigned: true,
            displayOrder: 2
        },
        {
            id: -1005,
            name: 'MONITOR',
            level: 2,
            parentId: -1001,
            link: '/monitormanagement',
            isAssigned: true,
            displayOrder: 4
        }
    ];

    if (isAuthenticated) {

        const menuMap: { [id: number]: MenuItem } = {};
        const rootItems: MenuItem[] = [];

        permissionBasedObjects.forEach(item => {
            menuMap[item.id] = { ...item, children: [] };
        });

        permissionBasedObjects.forEach(item => {
            if (item.parentId != null && menuMap[item.parentId]) {
                menuMap[item.parentId].children!.push(menuMap[item.id]);
            } else {
                rootItems.push(menuMap[item.id]);
            }
        });

        const sortItems = (items: MenuItem[]) => {
            items.sort((a, b) => a.displayOrder - b.displayOrder);
            items.forEach(item => {
                if (item.children && item.children.length > 0) {
                    sortItems(item.children);
                }
            });
        };


        return (
            <>

                <div className={"settingsGroup"} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    {isSuperUser && (
                        <>
                            <HeaderMenu items={rootItems} />
                            <Button
                                sx={{
                                    ...loginButtonStyles,
                                    marginRight: '18px'
                                }}
                                disableElevation
                                onClick={() => {
                                    window.location.href = "https://dev.azure.com/dbizdk/TravelHeart%20Family%20WebApp/_wiki/wikis/TravelHeart-Family-WebApp.wiki/7/Web-App-Changelogs";
                                }}
                            >
                                {process.env.REACT_APP_VERSION}
                            </Button>
                        </>
                    )}
                    <Button
                        sx={loginButtonStyles}
                        disableElevation
                        onClick={() => {
                            logoutUser();
                        }}
                    >
                        Logout
                    </Button>
                </div >
            </>
        );
    }
    else {
        return (
            <Button
                onClick={loginUser}
                sx={loginButtonStyles}
            >Login
            </Button>
        );
    }
}

export default LoginMenu;
